import { Container, Grid } from '@mui/material';
import { useHistory } from 'react-router-dom';
import settings from '../config/settings';

const img = (name: string) => `${process.env.PUBLIC_URL}/images/${name}`;

function BaseHeader() {
  const history = useHistory();

  return (
    <div className='main_header'>
      <Container style={{ maxWidth: '90%' }}>
        <Grid container alignItems='center' className='pt-2 pb-2' spacing={3}>
          <Grid item>
            <img
              src={img('logo_zelena.svg')}
              alt='Zelená podnikom'
              className='pointer'
              onClick={() => history.push('/')}
            />
          </Grid>
          {settings.SERVERROLE !== 'PROD' && (
            <Grid item className='bold redDanger ml-2' style={{ fontSize: '32px' }}>
              {settings.SERVERROLE}
            </Grid>
          )}
          <Grid item container xs spacing={10} justifyContent='flex-end'>
            <Grid item>
              <img style={{ height: '50px' }} src={img('footerLogo2.svg')} alt='logo' />
            </Grid>
            <Grid item>
              <img style={{ height: '50px' }} src={img('footerLogo1.svg')} alt='logo' />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default BaseHeader;
